import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

// Google sign-in disabled for the operator portal. If a stale OAuth
// redirect lands here with #session_id=... we simply bounce the user back
// to the login form with a clear error toast.
export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    toast.error("Google sign-in is disabled for staff accounts. Use username & password.");
    navigate("/login", { replace: true });
  }, [navigate]);

  return <div className="min-h-screen flex items-center justify-center text-[var(--text-muted)]">...</div>;
}
